import getDate from "./getDate";

export function excelDateToJSDate(excelDate) {
  const [date] = getDate(Math.round((excelDate - 25569) * 86400 * 1000));
  return date;
}